module.exports = __webpack_public_path__ + "static/media/poster.64e1577e.png";